import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';


@NgModule({
  exports: [],
  imports: [CommonModule],
  declarations: []
})
export class PipesModule {}
